import { createSelector } from '@reduxjs/toolkit'
import _, { memoize } from 'lodash'
import { AppRootState } from '../../AppState/AppStore'
import { LabsSelectors } from './StoreAdapter'

export const getLabSelector = createSelector(
  (state: AppRootState) => state,
  (state) =>
    memoize((id: string) => {
      return LabsSelectors.selectById(state, id)
    }),
)
